module.exports = __webpack_public_path__ + "img/icon_gkbz.16f9b2ac.png";